import type { IVersionedLine } from '../../../models/versioned-line.model';
import LineApiModel from './line.api-model';

export default class VersionedLineApiModel {
  gid!: string;
  technicalLineNumber!: string;
  versions!: LineApiModel[];

  public static mapToBusinessModel(apiModel: VersionedLineApiModel): IVersionedLine {
    return {
      gid: apiModel.gid,
      technicalLineNumber: apiModel.technicalLineNumber,
      versions: apiModel.versions ? apiModel.versions.map(LineApiModel.mapToBusinessModel) : [],
    };
  }
}
